/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/use-memo */
import { DependencyList, useCallback } from "react";

export const useClick = (callback, deps?: DependencyList) =>
  useCallback((e, ...args) => {
    e.preventDefault();
    e.stopPropagation();
    return callback(e, ...args);
  }, deps || []);
